document.addEventListener('click', async (event) => {
  const form = event.target.closest('form[action="/cart/add"]');
  if (form) {
    event.preventDefault(); // Evita la redirección
    const formData = new FormData(form);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData),
      });

      if (response.ok) {
        const cartItem = await response.json();
        // Actualiza el contador del carrito con Rebuy
        waitForSmartCartUpdate();
      } else {
        console.error('Error al agregar al carrito');
      }
    } catch (error) {
      console.error('Error en la solicitud:', error);
    }
  }
});

function updateCartCountWithRebuy() {
  const SmartCart = window.Rebuy?.SmartCart;
  if (SmartCart && SmartCart.itemCount) {
      const itemCount = SmartCart.itemCount();
      console.log('Rebuy item count:', itemCount);

      const cartCountElement = document.querySelector('.cart-link__bubble-num');
      const cartCountDisplay = document.querySelector('.cart-link__bubble');
      if (cartCountElement) {
        cartCountElement.textContent = itemCount;
        cartCountDisplay.classList.add('cart-link__bubble--visible');
      }
  } else {
      console.error('SmartCart no está disponible');
  }
}

function waitForSmartCartUpdate() {
  setTimeout(() => {
      updateCartCountWithRebuy();
  }, 1000);
}

